import ActivateBotPageContainer from "../../Component/ActivateBot/ActivateBot"

const ActivateBotPage = () => {
  return (
    <div className='page-body'>
      <ActivateBotPageContainer />
    </div>
  )
}

export default ActivateBotPage